import { render, staticRenderFns } from "./DeclassamentoMaterialePers.vue?vue&type=template&id=d8257b5c&scoped=true"
import script from "./DeclassamentoMaterialePers.vue?vue&type=script&lang=js"
export * from "./DeclassamentoMaterialePers.vue?vue&type=script&lang=js"
import style0 from "./DeclassamentoMaterialePers.vue?vue&type=style&index=0&id=d8257b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8257b5c",
  null
  
)

export default component.exports